import * as React from "react";

export const Lab = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7164 12.0469C14.4928 13.332 13.5825 15 12.1099 15H3.89012C2.41752 15 1.50719 13.332 2.28365 12.0469L5.44304 6.87891V2.75H5.22884C4.854 2.75 4.58625 2.47656 4.58625 2.09375V1.65625C4.58625 1.30078 4.854 1 5.22884 1H10.7979C11.146 1 11.4405 1.30078 11.4405 1.65625V2.09375C11.4405 2.47656 11.146 2.75 10.7979 2.75H10.5837V6.87891L13.7164 12.0469ZM5.68401 9.75H10.2892L9.00404 7.64453C8.92372 7.50781 8.8434 7.31641 8.8434 7.125V2.75H7.12983V7.125C7.12983 7.31641 7.07628 7.50781 6.99596 7.64453L5.68401 9.75Z"
    />
);
